import { render } from "./SeleccionarClienteModal.vue?vue&type=template&id=1b217e25&scoped=true"
import script from "./SeleccionarClienteModal.vue?vue&type=script&lang=js"
export * from "./SeleccionarClienteModal.vue?vue&type=script&lang=js"

import "./SeleccionarClienteModal.vue?vue&type=style&index=0&id=1b217e25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b217e25"]])

export default __exports__